import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PATH } from '../../constants';
import Button from '../button/v2/button';
import Container from '../containers/container';
import { ProfileDropdown } from '../dropdown/profile.dropdown';
import { HStack } from '../layouts/stack.layout';
import MobileNavigation from './mobile.navigation';

function NightMode() {
  const [currentTheme, setTheme] = useState<'bright-mode' | 'dark-mode'>(
    'dark-mode'
  );

  const currentlyInDarkMode = currentTheme === 'dark-mode';

  const handleOnClick = () => {
    if (currentlyInDarkMode) {
      setTheme('bright-mode');
    } else if (!currentlyInDarkMode) {
      setTheme('dark-mode');
    }
  };

  return (
    <Button
      color="glass"
      withButtonStyle
      onClick={handleOnClick}
      asIcon={currentTheme}
    />
  );
}

export default function AlternativeNavigation() {
  return (
    <>
      <Container extensions="mobile:hidden tablet-lg:block tablet-lg:px-[40px]">
        <HStack gap="base" justify="end" extensions="items-center">
          <NightMode />
          <Link to={`/${PATH.NOTIFICATIONS}`}>
            <Button color="glass" withButtonStyle asIcon="notifications" />
          </Link>
          <ProfileDropdown />
        </HStack>
      </Container>
      <Container extensions="mobile:block tablet-lg:hidden">
        <MobileNavigation />
      </Container>
    </>
  );
}
